export enum OriginEnum {
  East = 1,
  West = 2,
  Central = 3,
  Burris = 4,
  Indy = 5,
}
